import React from "react";
import Alumni from "../components/Alumni";
import HSLCAchievement from "../components/HSLCAchievement";

export default function Achievements() {
	return (

		<div className="container mx-auto py-8">
		<h2 className="text-3xl font-bold py-6 text-white bg-theme text-center" style={{ textShadow: "1px 1px 1px rgba(0, 0, 0, 0.5)" }}>Achievements</h2>
		<Alumni />
		<HSLCAchievement />
	</div>
	)
};